import {
  CaAnPage,
  DangKyAnBanTru,
  DangKyCaAnPage,
  DangKyHocSinhPage,
  DiemDanhAnPage,
  DotDangKyAnPage,
  HomePage,
  XacNhanAnHocSinhPage
} from './pages';
import BaoCaoDiemDanhPage from './pages/bao-cao/bao-cao-diem-danh';
import BaoCaoNgayPage from './pages/bao-cao/bao-cao-ngay';
import BaoCaoThangPage from './pages/bao-cao/bao-cao-thang';
import NgayNghiPage from './pages/danh-muc/ngay-nghi';
import ThucDonPage from './pages/thuc-don/danh-sach-thuc-don';



const routes = [
  {
    path: "/home/:tab?",
    component: HomePage,
  },
  {
    path: "/dang-ky-an-ban-tru",
    component: DangKyAnBanTru,
  },
  {
    path: "/food/thucdon",
    component: ThucDonPage,
  },
  {
    path: "food/ca-an",
    component: CaAnPage,
  },
  {
    path: "ngay-nghi",
    component: NgayNghiPage,
  },
  {
    path: "food/ca-an-truong",
    component: DangKyCaAnPage,
  },
  {
    path: "food/dot-dang-ky-an",
    component: DotDangKyAnPage,
  },
  {
    path: "food/dang-ky-hoc-sinh",
    component: DangKyHocSinhPage,
  },
  {
    path: "food/xac-nhan-an-hoc-sinh",
    component: XacNhanAnHocSinhPage,
  },
  {
    path: "food/diem-danh-an",
    component: DiemDanhAnPage,
  },
  {
    path: "food/bao-cao/ngay",
    component: BaoCaoNgayPage,
  },
  {
    path: "food/bao-cao/thang",
    component: BaoCaoThangPage,
  },
  {
    path: "food/bao-cao/diem-danh",
    component: BaoCaoDiemDanhPage,
  },
  //   {
  //   path: "/face-id/:tab?",
  //   component: Faceid,
  // },
];

export default routes.map((route) => {
  return {
    ...route,
  };
});
